import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Title, Box, Flex, Text } from "@mantine/core";
import { SegmentedScale } from "../../../components/form/SegmentedScale";

type Props = {
  form: any;
};

const ToleranciaAcosoLaboral = ({ form }: Props) => {
  const { t } = useTranslation();

  const options = [
    "Es aceptable",
    "Es inadecuado, pero tolerable",
    "Es inaceptable",
    "Es acoso laboral",
  ];
  const questions = [
    "Comentarios o bromas sobre características personales (raza, estatus social, apariencia física, forma de hablar).",
    "Creación o difusión de rumores sobre la vida privada de una persona.",
    "Comportamientos o mensajes amenazantes hacia una persona (verbal, escrito, digital).",
    "Comportamientos que aíslan a una persona, como ignorar su presencia, no hablarle o impedirle hacerlo.",
    "Críticas constantes al desempeño profesional o amenazas de medidas disciplinarias efectuadas de forma hostil.",
    "Modificar condiciones laborales (horario, lugar, funciones, permisos) de forma injustificada, recurrente o diferenciada respecto al resto del personal.",
    "No asignar trabajo a una persona o darle tareas inútiles, absurdas o con exigencias desproporcionadas.",
  ];
  const questionIds = [
    "TOL_001AL",
    "TOL_002AL",
    "TOL_003AL",
    "TOL_004AL",
    "TOL_005AL",
    "TOL_006AL",
    "TOL_007AL",
  ];

  // Combine questions with their corresponding IDs
  const questionsWithIds = questions.map((question, index) => ({
    question,
    id: questionIds[index],
  }));

  const handleScaleClick = (questionId: string, optionValue: string) => {
    form.setFieldValue(questionId, optionValue);
  };

  return (
    <Box px="sm">
      <Stack spacing="lg">
        <Title order={3}>{t("tolerance.label")}</Title>
        {/* Leyenda */}
        <Box
          p="md"
          bg="transparent"
          style={{
            borderRadius: 8,
            border: "1px solid #e9ecef",
          }}
          mb="xl"
        >
          <Text fw={400} mb="sm" color="gray.8">
            Leyenda
          </Text>
          <Flex wrap="wrap" gap="lg" justify="space-between">
            <Text size="sm" color="gray.7">
              1 = {options[0]}
            </Text>
            <Text size="sm" color="gray.7">
              2 = {options[1]}
            </Text>
            <Text size="sm" color="gray.7">
              3 = {options[2]}
            </Text>
            <Text size="sm" color="gray.7">
              4 = {options[3]}
            </Text>
          </Flex>
        </Box>

        <Stack spacing="xl">
          {questionsWithIds.map(({ question, id }) => (
            <Box key={id}>
              <Text size="sm" mb="md" style={{ textAlign: "justify" }}>
                {question}
              </Text>
              {form.errors[id] && (
                <Text fz="xs" color="red" mb="sm">
                  *Debes seleccionar una opción.
                </Text>
              )}
              <SegmentedScale
                value={form.values[id] || ""}
                onChange={(value) => handleScaleClick(id, value)}
                segments={options}
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default ToleranciaAcosoLaboral;
